const API_URL = process.env.REACT_APP_API_URL;

export const loginAdmin = async (username, password) => {
  try {
    const response = await fetch(`${API_URL}/api/admin`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        username,
        password
      }),
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || 'Login failed');
    }

    return data;
  } catch (error) {
    throw error;
  }
};

export const getAllBookings = async () => {
  try {
    const response = await fetch(`${API_URL}/api/admin/bookings`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || 'Failed to fetch bookings');
    }

    return data;
  } catch (error) {
    throw error;
  }
};

export const updateBookingStatus = async (bookingId, status, adminId) => {
  try {
    const response = await fetch(`${API_URL}/api/admin/bookings/${bookingId}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        status,
        adminId
      }),
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || 'Failed to update booking');
    }

    return data;
  } catch (error) {
    throw error;
  }
};


// HRV API functions
export const getAllHRV = async () => {
  try {
    const response = await fetch(`${API_URL}/api/hrv`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || 'Failed to fetch HRV properties');
    }

    return data;
  } catch (error) {
    throw error;
  }
};

export const createHRV = async (hrvData, adminId) => {
  try {
    const response = await fetch(`${API_URL}/api/hrv`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        ...hrvData,
        adminId
      }),
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || 'Failed to create HRV property');
    }

    return data;
  } catch (error) {
    throw error;
  }
};

export const updateHRV = async (hrvId, hrvData, adminId) => {
  try {
    const response = await fetch(`${API_URL}/api/hrv/${hrvId}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        ...hrvData,
        adminId
      }),
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || 'Failed to update HRV property');
    }

    return data;
  } catch (error) {
    throw error;
  }
};

export const deleteHRV = async (hrvId, adminId) => {
  try {
    const response = await fetch(`${API_URL}/api/hrv/${hrvId}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        adminId
      }),
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || 'Failed to delete HRV property');
    }

    return data;
  } catch (error) {
    throw error;
  }
};

// Popular Destinations API functions
export const getAllPopularDestinations = async () => {
  try {
    const response = await fetch(`${API_URL}/api/popular-destinations`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || 'Failed to fetch popular destinations');
    }

    return data;
  } catch (error) {
    throw error;
  }
};

export const createPopularDestination = async (destinationData, adminId) => {
  try {
    const response = await fetch(`${API_URL}/api/popular-destinations`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        ...destinationData,
        adminId
      }),
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || 'Failed to create popular destination');
    }

    return data;
  } catch (error) {
    throw error;
  }
};

export const updatePopularDestination = async (destinationId, destinationData, adminId) => {
  try {
    const response = await fetch(`${API_URL}/api/popular-destinations/${destinationId}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        ...destinationData,
        adminId
      }),
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || 'Failed to update popular destination');
    }

    return data;
  } catch (error) {
    throw error;
  }
};

export const deletePopularDestination = async (destinationId, adminId) => {
  try {
    const response = await fetch(`${API_URL}/api/popular-destinations/${destinationId}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        adminId
      }),
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || 'Failed to delete popular destination');
    }

    return data;
  } catch (error) {
    throw error;
  }
};